import { countWords } from "../../Utils";

/**
 * Determines which toast message (if any) to show when a Story Bible textarea
 * receives input that exceeds (or is already over) its word limit.
 *
 * @param {string} proposedValue - The new proposed text value (e.target.value)
 * @param {string|null|undefined} currentMetadataValue - The current stored value from metadata[key]
 * @param {number|null|undefined} limit - The word limit (null/undefined means no limit)
 * @returns {string|null} Toast message to show, or null if no toast needed
 */
export function resolveInputToast(proposedValue, currentMetadataValue, limit) {
  if (limit == null) return null;

  const proposedLength = countWords(proposedValue);
  if (proposedLength <= limit) return null;

  const currentValue = currentMetadataValue || "";
  const currentLength = countWords(currentValue);

  if (currentLength >= limit) {
    return `This field already exceeds the ${limit}-word limit. Your edit was not applied to avoid losing content.`;
  }

  return `The maximum length for this field is ${limit} words. Your text has been truncated to fit.`;
}
